import script from "./Trigger.vue?vue&type=script&setup=true&lang=ts"
export * from "./Trigger.vue?vue&type=script&setup=true&lang=ts"

import "./Trigger.vue?vue&type=style&index=0&id=e355aa8e&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
export default /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e355aa8e"]])